module.exports = __webpack_public_path__ + "static/media/profile.dcef3abe.jpg";